<template>
	<div class="dhlr-container">
		<van-nav-bar :title="'【换票】金额：' + (fpInfo.JE || '---')" fixed left-text="返回" left-arrow @click-left="clickTopLeft" />
		<!-- //切换发票种类 -->
		<div style="height:5px;background:#f6f6f7;"></div>
		<div class="kkpje-con">
			<span></span>
			<span @click="showAddSelect" class="money"> </span>
		</div>

		<van-form @submit="onSubmit">
			<!-- //发票类型    -->
			<van-field readonly clickable label="发票种类" :value="fpzl[this.formData.newfpzl]" placeholder="请选择发票种类" @click="showSelectFPZL = true" />
			<!-- //抬头类型    -->
			<van-field v-if="formData.newfpzl !== '004'" name="radio" label="抬头类型">
				<template #input>
					<van-radio-group icon-size="15px" checked-color="#ff6d00" v-model="tglx" direction="horizontal">
						<van-radio :disabled="InvoiceInfo.XGBZ === '0'" name="1">企业单位</van-radio>
						<van-radio :disabled="InvoiceInfo.XGBZ === '0'" name="2">个人/非企业</van-radio>
					</van-radio-group>
				</template>
			</van-field>

			<!-- //企业抬头 -->
			<div style="position: relative;" v-if="tglx === '1'">
				<div v-if="InvoiceInfo.XGBZ !== '0'" @click="getWxInv" class="wx-info-btn">
					<van-icon name="pending-payment" />
				</div>
				<van-field v-model="formData.KHMC" name="KHMC" required :disabled="InvoiceInfo.XGBZ === '0'" label="企业名称" placeholder="请输入企业名称" :rules="[{ required: true, message: '' }]" />
				<van-field v-model="formData.KHSH" name="KHSH" required :disabled="InvoiceInfo.XGBZ === '0'" label="企业税号" placeholder="请输入企业税号" :rules="[{ required: true, message: '' }]" />

				<van-field
					v-model="formData.QYDZ"
					name="QYDZ"
					label="企业地址"
					:required="formData.newfpzl === '004'"
					placeholder="请输入地址电话"
					:rules="formData.newfpzl === '004' ? [{ required: true, message: '' }] : []"
				/>
				<van-field
					v-model="formData.QYDH"
					name="QYDH"
					label="企业电话"
					:required="formData.newfpzl === '004'"
					placeholder="请输入地址电话"
					:rules="formData.newfpzl === '004' ? [{ required: true, message: '' }] : []"
				/>
				<van-field
					v-model="formData.KHYH"
					name="KHYH"
					label="开户银行"
					:required="formData.newfpzl === '004'"
					placeholder="请输入开户银行"
					:rules="formData.newfpzl === '004' ? [{ required: true, message: '' }] : []"
				/>
				<van-field
					v-model="formData.YHZH"
					name="YHZH"
					label="银行账户"
					:required="formData.newfpzl === '004'"
					placeholder="请输入银行账户"
					:rules="formData.newfpzl === '004' ? [{ required: true, message: '' }] : []"
				/>
			</div>
			<!-- //个人类型抬头 -->
			<div style="position: relative;" v-if="tglx === '2'">
				<div v-if="InvoiceInfo.XGBZ !== '0'" @click="getWxInv" class="wx-info-btn">
					<van-icon name="pending-payment" />
				</div>
				<van-field v-model="formData.KHMC" name="发票抬头" required :disabled="InvoiceInfo.XGBZ === '0'" label="发票抬头" placeholder="请输入发票抬头" :rules="[{ required: true, message: '' }]" />
			</div>
			<div style="height:20px;color: #b5b3b3; font-size: 9pt;line-height:20px;padding-left:15px;">收票方式 :</div>
			<!-- //收票方式-电子邮箱 -->
			<div>
				<van-field v-if="formData.newfpzl !== '004' && formData.newfpzl !== '007'" v-model="formData.KHSJ" name="KHSJ" label="手机号码" placeholder="请输入手机号码" />
				<van-field
					v-if="formData.newfpzl !== '004' && formData.newfpzl !== '007'"
					v-model="formData.KHYJ"
					name="电子邮箱"
					required
					label="电子邮箱"
					srequired
					placeholder="请输入接收发票的电子邮箱"
					:rules="[{ required: true, message: '' }]"
				/>
			</div>
			<!-- 收票方式-邮寄 -->
			<div>
				<van-field
					v-model="formData.SJR"
					v-if="formData.newfpzl === '004' || formData.newfpzl === '007'"
					name="SJR"
					required
					label="收件人"
					:rules="[{ required: true, message: '' }]"
					placeholder="请输入收件人"
				/>
				<van-field
					v-model="formData.KHSJ"
					v-if="formData.newfpzl === '004' || formData.newfpzl === '007'"
					name="KHSJ"
					required
					:rules="[{ required: true, message: '' }]"
					label="收件人电话"
					placeholder="请输入收件人电话"
				/>
				<van-field
					v-model="indexDQ"
					is-link
					required
					v-if="formData.newfpzl === '004' || formData.newfpzl === '007'"
					readonly
					:rules="[{ required: true, message: '' }]"
					label="地区"
					placeholder="请选择所在地区"
					@click="showAddSelect = true"
				/>
				<van-field
					required
					v-model="SJDZ"
					v-if="formData.newfpzl === '004' || formData.newfpzl === '007'"
					name="SJDZ"
					:rules="[{ required: true, message: '' }]"
					label="详细地址"
					placeholder="请输入详细地址"
				/>
			</div>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">提交</van-button>
			</div>
		</van-form>
		<!-- 地址选择 -->
		<van-popup position="bottom" v-model="showAddSelect">
			<van-area title="选择地区" @cancel="showAddSelect = false" @confirm="changeArea" :area-list="areaList" />
		</van-popup>

		<!-- 发票种类选择 -->
		<van-popup v-model="showSelectFPZL" round position="bottom">
			<van-picker show-toolbar :columns="hplxColumns" @cancel="showSelectFPZL = false" @confirm="onConfirm" />
		</van-popup>
	</div>
</template>

<script>
	import { areaList } from "@vant/area-data";
	import Vue from "vue";
	import { Form } from "vant";
	import { Field } from "vant";
	import { RadioGroup, Radio } from "vant";
	import { Icon } from "vant";
	import { Toast } from "vant";
	import { Button } from "vant";
	import { Area } from "vant";
	import { Popup } from "vant";
	import { Picker } from "vant";
	import { NavBar } from "vant";

	Vue.use(NavBar);
	Vue.use(Picker);
	Vue.use(Popup);
	Vue.use(Area);
	Vue.use(Button);
	Vue.use(Toast);
	Vue.use(Icon);
	Vue.use(Radio);
	Vue.use(RadioGroup);
	Vue.use(Form);
	Vue.use(Field);
	import $ from "jquery";
	let domain = "/SHKJ";
	let s_pappid = "";
	let str_khlx = "";
	let seturlData;
	import { Base64 } from "js-base64";
	let ticket = "";
	function setInvoice() {
		//第一步设置
		return new Promise((res, rej) => {
			$.ajax({
				url: "https://www.51dzfp.cn/SHKJ/WXJS/seturl",
				type: "POST",
				data: "accessToken=" + access_token,
				cache: false,
				async: false,
				dataType: "json",
				success: function(data) {
					seturlData = JSON.parse(Base64.decode(data.DATA));
					s_pappid = seturlData.invoice_url.match(/s_pappid.*/)[0].replace("s_pappid=", "");
					res(data);
				},
			}).fail(function(xhr, textStatus, err) {
				alert("Error: " + err);
			});
		});
	}
	function getTicket() {
		//第二部
		return new Promise((res, rej) => {
			$.ajax({
				url: "https://www.51dzfp.cn/SHKJ/WXJS/Getwxcar_Ticket",
				type: "POST",
				data: "accessToken=" + access_token,
				contentType: "application/x-www-form-urlencoded;charset=UTF-8",
				cache: false,
				async: false,
				dataType: "json",
				success: function(data) {
					ticket = JSON.parse(Base64.decode(data.DATA)).ticket;
					res(data);
				},
			}).fail(function(xhr, textStatus, err) {
				alert("Error: " + err);
			});
		});
	}
	function timest() {
		var tmp = Date.parse(new Date()).toString();
		tmp = tmp.substr(0, 10);
		return tmp;
	}
	import { mapState } from "vuex";
	export default {
		computed: {
			...mapState(["dhInfo", "fpInfo", "InvoiceInfo", "FPZL", "allFpzl"]),
		},
		data() {
			return {
				fpzl: {
					//发票总类
					"028": "电子专票",
					"004": "纸质专票",
					"007": "纸质普票",
					"026": "电子普票",
					"020": "全电专票",
					"021": "全电普票",
				},
				columns: [
					//发票种类列表
					{
						text: "电子普票",
						value: "026",
					},
					{
						text: "纸质专票",
						value: "004",
					},
					{
						text: "纸质普票",
						value: "007",
					},
					{
						text: "全电专票",
						value: "020",
					},
					{
						text: "全电普票",
						value: "021",
					},
					{
						text: "电子专票",
						value: "028",
					},
				],
				hplxColumns: [],
				noFpzl: false,
				showSelectFPZL: false, //是否给客户选择发票种类
				indexDQ: "",
				indexValue: "",
				showAddSelect: false,
				areaList,
				type: "",
				tglx: "1",
				SJR: "",
				SJDZ: "",
				SJRDH: "",
				formData: {
					newfpzl: "", //新发票种类
					// khyh: '',               //客户银行
					// khdz: '',               //客户地址
					// ktdz: '',               //快递地址
					// sjr: '',                //手机号码
					// khsh: '',               //客户税号
					// khyj: '',               //客户邮件
					// khsj: '',               //客户手机

					// spid: '',               //税盘ID
					// xtlsh: '',              //系统流水号
					// fpzl: '',               //旧发票种类
					// je: '',                 //金额

					KHMC: "",
					KHSH: "",
					KHDZ: "", //客户地址电话
					KHSJ: "",
					KHYJ: "",
					KTDZ: "",
					SJR: "",
					QYDZ: "", //企业地址
					QYDH: "", //企业电话
					KHYH: "",
					YHZH: "", //开户银行
				},
				postData: null,
			};
		},
		methods: {
			formD(obj) {
				const formData = new URLSearchParams();
				Object.keys(obj).forEach((key) => {
					if (obj[key] instanceof Array) {
						obj[key].forEach((item) => {
							formData.append(key, item);
						});
						return;
					}
					formData.append(key, obj[key]);
				});
				return formData;
			},
			clickTopLeft() {
				this.$parent.showChangeFpzl = false;
			},
			changeArea(data) {
				//获取三级联动的地址
				this.indexDQ = "";
				for (let x of data) {
					this.indexDQ += x.name;
				}
				this.showAddSelect = false;
			},
			//提交发票
			async onSubmit() {
				this.$parent.$parent.loading = true;
				//专票加收票地址进去,普票一样
				if (this.formData.newfpzl === "004" || this.formData.newfpzl === "007") {
					this.formData.KTDZ = this.indexDQ + this.SJDZ;
				}
				this.formData.KHDZ = this.formData.QYDZ + this.formData.QYDH;
				this.formData.KHYH = this.formData.KHYH + this.formData.YHZH;
				//开具发票的操作
				try {
					//电子发票领票到微信开票的操作
					let data = {};
					Object.keys(this.formData).forEach((item) => {
						//解决值为null的问题
						if (this.formData[item] == undefined || this.formData[item] == null) {
							data[item.toLowerCase()] = "";
						} else {
							data[item.toLowerCase()] = this.formData[item];
						}
					});
					data.xtlsh = this.fpInfo.SucessList[0].XTLSH;
					//发生换票指令
					let mesRes = await this.$axios.post(urlHead + "/NEWKP/KPGL/ZDHC", this.formD(data));
					this.$parent.$parent.loading = false;
					if (mesRes.Result == "1") {
						this.$parent.$parent.active = 2;
						this.$store.commit("FPZL", this.formData.newfpzl);
						this.$store.commit("isHP", true);
						this.$store.commit("fpInfo", { ...this.fpInfo, KHMC: this.formData.KHMC, KHSH: this.formData.KHSH });
						this.clickTopLeft();
					} else {
						Toast(mesRes.Message);
					}
				} catch (err) {
					this.$parent.loading = false;
				}
			},
			onConfirm(data) {
				//选择发票种类
				if (data.value === "004") {
					this.tglx = "1";
				}
				this.formData.newfpzl = data.value;
				this.showSelectFPZL = false;
			},
			///初始化
			getMatic() {
				console.log("fpInfo", this.fpInfo);
				this.formData.JE = this.fpInfo.JE;
				this.formData.SPID = this.fpInfo.SPID;
				this.formData.FPZL = this.fpInfo.FPZL;
				this.formData.orderid = this.fpInfo.SucessList ? this.fpInfo.SucessList[0].XTLSH : "";
				this.formData.DPID = this.fpInfo.DPID;
				this.formData.KHMC = this.fpInfo.KHMC;
				this.formData.KHSH = this.fpInfo.KHSH;
				this.initFpzl();
				// this.formData.KHDZ=(this.fpInfo.KHDZ).replace(/[0-9].*[0-9]/,'');//客户地址
				try {
					this.formData.QYDZ = this.fpInfo.KHDZ.replace(/\d{3}-\d{8}|\d{4}-\d{7}|1[3-9]\d{9}/, ""); //企业地址
					this.formData.QYDH = this.fpInfo.KHDZ.match(/\d{3}-\d{8}|\d{4}-\d{7}|1[3-9]\d{9}/)[0]; //企业电话
				} catch (e) {}
				try {
					this.formData.KHYH = this.fpInfo.KHYH.trim().replace(/[0-9].*[0-9]/, ""); //开户银行
					this.formData.YHZH = this.fpInfo.KHYH.trim().match(/[0-9].*[0-9]/)[0]; //银行账号
				} catch (e) {}
				//设置抬头类型
				if (this.formData.FPZL === "004" || (this.formData.KHSH != undefined && this.formData.KHSH !== "")) {
					this.tglx = "1";
				} else {
					this.tglx = "2";
				}
				this.hplxColumns = [];
				let hplxs = this.fpInfo?.HPLX?.split("|");
				if (hplxs) {
					for (let i = 0; i < hplxs.length; i++) {
						let items = this.columns.filter((item) => item.value == hplxs[i]);
						this.hplxColumns.push(items[0]);
					}
				}
			},
			getWxInv() {
				//获取微信抬头信息
				let that = this;
				wx.invoke(
					"chooseInvoiceTitle",
					{
						scene: 1,
					},
					function(res) {
						let str = JSON.stringify(res.choose_invoice_title_info);
						while (str.indexOf("\\") >= 0) str = str.replace("\\", "");
						str = str.substr(1, str.length - 2);
						let s = eval("(" + str + ")");
						that.formData.KHMC = s.title;
						that.formData.KHSH = s.taxNumber;
						that.formData.KHSJ = s.telephone;
						try {
							that.formData.QYDZ = s.companyAddress; //企业地址
							that.formData.QYDH = s.telephone; //企业电话
						} catch (e) {}
						try {
							that.formData.KHYH = s.bankName; //开户银行
							that.formData.YHZH = s.bankAccount; //银行账号
						} catch (e) {}
					}
				);
			},
			initFpzl() {
				//初始化发票种类
				let fpzl = this.formData.FPZL;
				// this.columns = this.columns.filter(item => item.value != fpzl)
				try {
					this.$set(this.formData, "newfpzl", fpzl);
				} catch (e) {
					console.log("发生了错误" + e);
					this.$set(this.formData, "newfpzl", "");
				}
			},
		},
		created() {
			this.getMatic();
		},
		mounted() {
			console.warn("fpInfo", this.fpInfo);
			console.warn("dhInfo", this.dhInfo);
		},
	};
</script>

<style lang="less" scoped>
	.wx-info-btn {
		position: absolute;
		z-index: 999;
		top: 12px;
		right: 12px;
		font-size: 1.2rem;
		color: blue;
	}
	.kkpje-con {
		margin-bottom: 10px;
		line-height: 40px;
		height: 40px;
		background: #fff;
		padding: 0 15px;
		display: flex;
		align-items: center;
		.money {
			margin-left: 20px;
			color: orange;
			font-weight: 600;
			display: flex;
			align-items: center;
			i {
				margin-right: 3px;
			}
		}
	}
</style>
